<div class="footer-wrapper">
  <div class=" footer " [ngClass]="{'arabic': lang === 'ar'}">
    <div class="container">
      <!-- desktop section footer text-->
      <div class="row mb-4 mt-0  align-items-center d-none d-lg-flex">
        <div class="col-lg-12">
          <p class="mb-0 pb-0 font-12 fw-regular footer-info ">
            {{"footer_head" | translate}}
          </p>
        </div>
      </div>
      <!----->
      <div class="row mb-0  d-flex align-items-center justify-content-between bottom">
        <div class="col-lg-3 order-3 order-lg-1">
          <div class="d-flex align-items-center justify-content-center justify-content-xl-start pt-3 py-xl-0">
            <a href=""> <img src="./assets/images/footer-logo.svg" alt="" class="img-fluid"></a>
            <p class="fw-regular font-12  mb-0">
              {{"copyright" | translate}}
            </p>
          </div>
        </div>
        <div class=" col-lg-6 order-2 order-lg-2">
          <div class="footer-links-wrapper">

            <div class="footer-links">
              <a [href]="lang+'/terms-and-conditions'">
                <span class="mob-links">
                  {{"terms" | translate}}
                </span>
              </a>
            </div>

            <div class="footer-links">
              <a [href]="lang+'/privacy-policy'">
                <span class="mob-links">
                  {{"privacy" | translate}}
                </span>
              </a>
            </div>

            <div class="footer-links mob-links"><a [href]="lang+'/cookies'">
                {{"cookies" | translate}}</a></div>

            <div class="footer-links"><a href='partner'>
                {{"partner" | translate}}</a> </div>

          </div>
        </div>
        <div class="col-lg-3 order-1 order-lg-3">
          <div class="d-flex justify-content-center justify-content-xl-end py-4 py-xl-0">
            <a href="https://twitter.com/BestWeb3_" target="_blank">
              <img class="mx-2" src="./assets/images/grey-twitter.svg" alt=""></a>
            <a href="https://t.me/BestWeb3Official" target="_blank">
              <img class="mx-2" src="./assets/images/telegram-grey.svg" alt=""></a>
            <a href="https://discord.gg/ujKmVVycsW" target="_blank">
              <img class="mx-2" src="./assets/images/discord-grey.svg" alt=""></a>
            <a href="https://linktr.ee/bestweb3official" target="_blank">
              <img class="mx-2" src="./assets/images/link-grey.svg" alt=""></a>
          </div>
        </div>
      </div>
      <!-- mobile section footer text-->
      <div class="row mt-0 align-items-center d-flex d-lg-none">
        <div class="col-lg-12">
          <p class="text-center  font-12 fw-regular footer-info ">
            {{"footer_head" | translate}}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>